import { createClient } from "@supabase/supabase-js";

const FALLBACK_SUPABASE_URL = "https://ksmnykauzrikxeowkiia.supabase.co";
const FALLBACK_SUPABASE_PUBLISHABLE_KEY = "sb_publishable_HkiQorraNXbpaue2-XcoOA_40Ar-aOZ";

export const SUPABASE_URL =
  process.env.REACT_APP_SUPABASE_URL || FALLBACK_SUPABASE_URL;

export const SUPABASE_PUBLISHABLE_KEY =
  process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY ||
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  FALLBACK_SUPABASE_PUBLISHABLE_KEY;

export const supabase = createClient(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      persistSession: true, // ✅ هذا مهم جدًا
      autoRefreshToken: true,
      detectSessionInUrl: true,
      storage: window.localStorage,
    },
  },
);
